import { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getEnvironment } from '../utils/environment';
import { clearCache as clearCacheAction } from '../actions/app.actions';

interface UseCache {
	/**
	 * Clears cached data on both session and localstorage
	 * @returns
	 */
	clearCache: () => void;
}

export const useCache: () => UseCache = () => {
	const dispatch = useDispatch();
	const hostname = window.location.hostname;

	const storeKey = useMemo(() => `INFO_360_${getEnvironment()}`, [hostname]);

	const clearCache = useCallback(() => {
		dispatch(clearCacheAction());
		try {
			localStorage.removeItem(storeKey);
			sessionStorage.removeItem(storeKey);
		} catch (e) {
			console.error(e);
		}
	}, [storeKey]);

	return {
		clearCache,
	};
};
